import { createContext, FunctionComponent, PropsWithChildren, useContext } from 'react';

export const UrlContext = createContext<URL | undefined>(undefined);

export const useUrlContext = (): URL => {
  const context = useContext(UrlContext);
  if (context === undefined) {
    throw new Error('useUrlContext must be used within a UrlContext.Provider');
  }
  return context;
};

export const UrlContextProvider: FunctionComponent<PropsWithChildren<{ url: URL }>> = ({
  children,
  url,
}) => {
  return <UrlContext.Provider value={url}>{children}</UrlContext.Provider>;
};
